import html2canvas from "html2canvas-pro";

// Create a link, download the image, and remove the link
const downloadImage = (blob, fileName) => {
  const fakeLink = window.document.createElement("a");
  fakeLink.style = "display:none;";
  fakeLink.download = fileName;
  fakeLink.href = blob;

  document.body.appendChild(fakeLink);
  fakeLink.click();
  document.body.removeChild(fakeLink);
  fakeLink.remove();
};

// Export the element as an image using all the provided options
const exportAsImage = async (el, imageFileName, imageFileType, imageTransparency, theme, handleExport, contentPath) => {
  if (contentPath !== undefined) {
    el = el.querySelector(`:scope ${contentPath}`);
  }

  // If the element is too large, reduce the scale to avoid memory issues that can cause the export to fail
  let scale = 4;
  if (el.clientWidth > 1500 || el.clientHeight > 1500) {
    scale = 2;
  } else if (el.clientWidth > 3000 || el.clientHeight > 3000) {
    scale = 1;
  }

  const canvas = await html2canvas(el, { 
    scale: scale, 
    backgroundColor: imageTransparency ? "transparent" : theme ? theme.palette.background.paper : "white",
  });

  const type = `image/${imageFileType}`;
  const image = canvas.toDataURL(type);

  if (image) {
    downloadImage(image, imageFileName);
  }

  handleExport(!!image);
};

export default exportAsImage;
